import React, { useEffect, useState } from "react";
import { Card, CardBody, Container } from "reactstrap";
import Loader from "react-loader-spinner";
import useOrgIdentifer from "@hooks/org_identifier";
import { useKibanaAuthentication } from "../../hooks/useKibanaAuthentication";
import { KIBANA_PLM_URL } from "../../Common/KibanaAPIEndpoints/KibanaAPIEndpoints";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

const DOMAIN_URL = KIBANA_PLM_URL.replace(/\/$/, "");

function getIframeUrl(identifier) {
  return `${DOMAIN_URL}/s/pc-${identifier}-space/app/dashboards`;
}

export default function PlmSelfServiceDashboard() {
  const identifier = useOrgIdentifer();
  const { setToken } = useKibanaAuthentication(identifier);
  const [loading, setLoading] = useState(true);
  const iframeUrl = getIframeUrl(identifier);

  useEffect(() => {
    if (!identifier) return;
    (async () => {
      try {
        setLoading(true);
        await setToken(KIBANA_PLM_URL);
      } catch (err) {
        console.error("Failed to load Analytics dashboard", err);
      } finally {
        setLoading(false);
      }
    })();
  }, [identifier]);

  if (loading) {
    return (
      <Container fluid>
        <Card>
          <CardBody
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "400px" }}
          >
            <Loader
              type="Puff"
              color="#00BFFF"
              height={100}
              width={100}
              className="pc-loader"
            />
          </CardBody>
        </Card>
      </Container>
    );
  }

  return (
    <iframe
      src={iframeUrl}
      title="PLM Self Service Dashboard"
      height="100%"
      width="100%"
      style={{ border: "none", minHeight: "calc(100vh - 120px)" }}
    />
  );
}
